import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-68" data-mp="aua4y8rf39qx">
      <div className="mx-auto max-w-4xl" data-id="element-69" data-mp="ftmtcxxxsovm">
        <SectionHeading tone="dark" eyebrow="Your professional nutrition toolkit" title="Five Specialized Tools Included With Your Purchase" subtitle="Practical resources designed to support specific tasks within your insulin resistance nutrition care workflow." data-id="element-70" data-mp="fslj2voqw6ey" />

        <div className="mt-10 space-y-10" data-id="element-71" data-mp="3o3prvy1bjsvc">
          {bonuses.map(bonus => <article key={bonus.number} className="overflow-hidden rounded-2xl bg-white sm:rounded-3xl" data-id="element-72" data-mp="3t182dsuzig5g">
              <div className="flex items-center justify-center gap-2 bg-gold px-4 py-2.5 text-navy" data-id="element-73" data-mp="1mb1l5epgunat">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="1r8jwfbqyhelz" />
                <span className="text-sm font-black uppercase tracking-widest" data-id="element-75" data-mp="3idejzzwf3s28">Bonus #{bonus.number}</span>
              </div>

              <img src={bonus.image} alt={`${bonus.title} mockup`} className="block w-full bg-white" loading="lazy" data-id="element-76" data-mp="3detsqpz58ipx" />

              <div className="px-5 pb-6 pt-2 sm:px-8 sm:pb-8" data-id="element-77" data-mp="3r8uodaustpm2">
                <h3 className="font-serif text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-78" data-mp="3n6g18ek3k3oz">{bonus.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-79" data-mp="2zfu77r6xgjxz">{bonus.description}</p>

                <p className="mt-5 text-sm font-bold uppercase tracking-wider text-navy" data-id="element-80" data-mp="2uiburqtpbml8">Inside, you'll find:</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-81" data-mp="38e5v3lget3mq">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-82" data-mp="nprj961bulk3">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-83" data-mp="irg90u74e91c" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-6 flex items-center justify-between gap-3 rounded-xl bg-cream px-4 py-3" data-id="element-84" data-mp="3hh8273r1q02y">
                  <span className="text-[15px] text-muted" data-id="element-85" data-mp="3lknvpr7tjkbf">
                    Reference value: <span className="font-bold text-danger line-through" data-id="element-86" data-mp="3qj7kdzdsra7h">${bonus.value}</span>
                  </span>
                  <span className="rounded-lg bg-cta px-3 py-1.5 text-sm font-black uppercase tracking-wide text-white" data-id="element-87" data-mp="2ttgdt1s8dwlb">
                    Included free
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-88" data-mp="37jtnp9oonlda">
          <CTAButton tone="dark" label="Yes, I want all five professional tools" note="All five specialized tools are included with your $27 purchase." data-id="element-89" data-mp="37kv844rl9k7o" />
        </div>
      </div>
    </section>;
}